<script>
import Vue from 'vue'
import router from '@/modules/router'
import InputLine from '@/components/atoms/inputlib/components/InputLine'
import FormValidation from '@/components/atoms/FormValidation'
import ButtonLoader from '@/components/atoms/ButtonLoader'
import ModalForgotPassword from '@/components/organism/modal/ModalForgotPassword'
import SocialAuth from '@/components/organism/SocialAuth'
import policies from '@/modules/mixins/policies'

export default {
    name: 'Login',
    components: {
        SocialAuth,
        ModalForgotPassword,
        ButtonLoader,
        FormValidation,
        InputLine,
    },
    mixins: [policies],
    data() {
        return {
            loading: false,
            disabled: true,
            error: null,
            model: {
                email: null,
                password: null,
            },
        }
    },
    methods: {
        login() {
            this.loading = true
            this.error = null
            this.$user
                .login(this.model)
                .then(() => {
                    if (this.$user.onlyCloudCanteen)
                        this.$router.push({
                            name: 'canteen-pickup',
                        })
                    else if (this.$route.query.redirect)
                        this.$router.push(this.$route.query.redirect, () => {
                            this.$location.check(this.$route)
                        })
                    else
                        this.$router.push({
                            name: 'restaurant-list',
                            params: { setLocation: true },
                        })
                })
                .catch((e) => {
                    this.error = e.message
                })
                .finally(() => {
                    this.loading = false
                })
        },
        onChange() {
            this.error = null
        },
    },
    beforeRouteEnter(to, from, next) {
        if (Vue.prototype.$user.isLoggedIn) router.replace({ name: 'restaurant-list' })
        next(() => {
            if (from.name === 'restaurant') {
                router.replace({ query: { redirect: from.fullPath } })
            }
        })
    },
}
</script>

<template lang="pug">
.container-fluid.container-lg
    .row.mb-11
        .col-12.col-lg-4.offset-lg-4
            h1.mt-10.text-center.font-weight-bold {{$t('login.log_in')}}
            .mb-6.text-center.font-weight-semibold {{$t('login.new_user')}}&nbsp;
                router-link(:to="{name: 'signup'}") {{$t('login.sign_up')}}
            //social-auth(:config="config")
            form-validation(@submit="login")
                input-line(v-model="model.email" type="email" @input="onChange" :error="error !== null" :placeholder="$t('labels.placeholder.email')" live required)
                input-line(v-model="model.password" type="password" @input="onChange" :error="error" :placeholder="$t('labels.placeholder.psw')" live required)
                template(v-slot:submit)
                    button-loader.btn.btn-primary.btn-block.mt-5.mb-4(type="submit" :loading="loading" inline) {{$t('login.log_in')}}
            modal-forgot-password

</template>
